import { Component } from '@angular/core';
import { Md5 } from '../../../services/md5';
import { AuthenticationService } from '../../../services/authentication.service';
import { ModalService } from '../../../services/modal.service';

@Component({
  templateUrl : './change-pwd.html',
  styleUrls: ['./change-pwd.scss'],
})

export class ChangePwdPage {
  /**
   * 아이디
   */
  id: string;

  /**
   * 비밀번호
   */
  nowPwd: string = '';

  /**
   * 새 비밀번호
   */
  changePwd1: string = '';

  /**
   * 새 비밀번호 확인
   */
  changePwd2: string = '';

  /**
   * @constructor
   */
  constructor(
    private $modal: ModalService,
    private $authService: AuthenticationService) {
    // 사용자 아이디 저장
    this.id = localStorage.getItem('userId');
  }

  private $showModal(title: string, content: string, imageSrc?: string) {
    const config = imageSrc ?
      { title, content, imageSrc } : { title, content };
    this.$modal.open(config);
  }

  isError() {
    return this.changePwd1 !== this.changePwd2;
  }

  // 확인 클릭
  submit() {
    // 변경 할 비밀번호가 같은지 확인
    if (this.isError()) {
      this.$showModal('입력 오류', '변경 할 비밀번호가 서로 다릅니다.');
      return;
    }
    // 빈칸 확인
    if (!this.nowPwd || !this.changePwd1 || !this.changePwd2) {
      this.$showModal('빈칸 입력', '빈칸을 입력해주세요.');
      return;
    }
    // 현재 비밀번호와 변경 할 비밀번호 전달.
    this.$authService.changePwd(
      this.id,
      Md5.hashAsciiStr(this.nowPwd).toString(),
      Md5.hashAsciiStr(this.changePwd1).toString()).
      subscribe(
      () => {
        this.$showModal('요청 성공', '비밀번호 변경에 성공했습니다.');
      },
      (err) => {
        err && (err.status === 400) ?
          this.$showModal('입력 오류', '비밀번호를 확인해주세요.') :
          this.$showModal('서버 오류', '변경에 문제가 있습니다.');
      });
  }
}
